/**
 * App-Zugänge für Mitarbeitende: Einladung per Code/Link/QR, Lizenzstand,
 * Sperren. Büro und Inhaber kommen mit „Aufs Handy“ (Code fürs eigene Konto)
 * in die App, ihr Mitarbeiter-Eintrag hängt per „Das bin ich“ an ihrem Login. Mitarbeiter bekommen nur die iPhone-App, keinen Desktop. Logik und
 * Rechte liegen in der DB (Migration 20261020200_app_zugang), die Annahme in der
 * Edge Function `einladung`.
 */

import { supabase } from './supabaseClient';

/** Installationslink der iPhone-App. Bis zum App-Store-Start der öffentliche TestFlight-Link. */
export const APP_INSTALL_URL = process.env.REACT_APP_INSTALL_URL || 'https://testflight.apple.com/join/hWnX412G';

export const EINLADUNG_BASIS = 'https://optero.app/e/';

/** Nur-App-Konten: kein Zugang zum Desktop, sehen nur Eigenes. 'monteur'/'azubi' = ältere Namen. */
export const APP_ROLLEN = ['mitarbeiter', 'monteur', 'azubi'];

/** ZA7B69C2 → ZA7B-69C2 */
export const codeAnzeige = (code) => (code ? `${code.slice(0, 4)}-${code.slice(4)}` : '');

export async function ladeZugaenge() {
    const { data, error } = await supabase.rpc('app_zugaenge');
    if (error) throw new Error(error.message);
    return data; // null = keine Berechtigung
}

function fehlertext(error) {
    if (error.message?.includes('LIZENZEN_VOLL')) return 'Alle Lizenzen sind belegt.';
    return error.message;
}

export async function einladen(mitarbeiterId) {
    const { data, error } = await supabase.rpc('einladung_erstellen', { p_mitarbeiter: mitarbeiterId });
    if (error) throw new Error(fehlertext(error));
    return data?.[0];
}

export async function einladungZurueckziehen(mitarbeiterId) {
    const { error } = await supabase.rpc('einladung_widerrufen', { p_mitarbeiter: mitarbeiterId });
    if (error) throw new Error(error.message);
}

export async function zugangSperren(mitarbeiterId, sperren = true) {
    const { error } = await supabase.rpc('zugang_sperren', { p_mitarbeiter: mitarbeiterId, p_sperren: sperren });
    if (error) throw new Error(fehlertext(error));
}

export function einladungsText({ vorname, betrieb, code }) {
    return `Hallo ${vorname || ''}, hier ist dein Zugang zur HeyOptero-App${betrieb ? ` von ${betrieb}` : ''}:\n\n`
        + `${EINLADUNG_BASIS}${code}\n\nCode: ${codeAnzeige(code)}`;
}

/** wa.me braucht die Nummer international ohne + und führende Nullen. */
export function whatsappLink(telefon, text) {
    let nr = String(telefon || '').replace(/[^\d+]/g, '');
    if (nr.startsWith('+')) nr = nr.slice(1);
    else if (nr.startsWith('00')) nr = nr.slice(2);
    else if (nr.startsWith('0')) nr = `49${nr.slice(1)}`;
    return `https://wa.me/${nr}?text=${encodeURIComponent(text)}`;
}

/** „Aufs Handy“: Code fürs eigene Konto, 15 Minuten, einmal. */
export async function handyCodeErstellen() {
    const { data, error } = await supabase.rpc('handy_anmeldung_erstellen');
    if (error) throw new Error(error.message);
    return data?.[0];
}

export async function handyCodeEingeloest(code) {
    const { data } = await supabase.rpc('handy_anmeldung_eingeloest', { p_code: code });
    return !!data;
}

/** „Das bin ich“ (null = Verknüpfung lösen). Ein vorhandenes App-Konto des Mitarbeiters wird zusammengeführt. */
export async function dasBinIch(mitarbeiterId) {
    const { data, error } = await supabase.rpc('mitarbeiter_mir_zuordnen', { p_mitarbeiter: mitarbeiterId });
    if (error) throw new Error(error.message);
    return data;
}

/** Öffentlich, ohne Login — für die Einladungsseite. */
export async function pruefeEinladung(code) {
    const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/einladung`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', apikey: process.env.REACT_APP_SUPABASE_ANON_KEY },
        body: JSON.stringify({ action: 'pruefen', code }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || 'Einladung nicht gefunden.');
    return data;
}
